module.exports = __webpack_public_path__ + "img/player_run_003.3473e7f3.png";